import { gql } from "@apollo/client";

export default gql`
  query getRaceWagers(
    $accountId: Int!
    $startDate: String
    $endDate: String
    $wagerTypes: [String!]
  ) {
    wagerHistory(
      accountId: $accountId
      beginDate: $startDate
      endDate: $endDate
      wagerTypes: $wagerTypes
    ) {
      totals(page: { current: 0, results: 1 }) {
        totalCount
      }
    }
  }
`;
